﻿'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope) {
    $(scope).on('change', function() {
        var url = this.value;
        $(location).attr('href', url);
    });
}
